import React, { Component } from 'react';

import CheckboxSection from "./CheckboxSection";
import AccesoSimultaneo from "./AccesoSimultaneo";
import ConfiguracionContrasenia from "./ConfiguracionContrasenia";

const ModoPersonalizado = (props) => {
    return (
        <div className="">
            <div>
                <div className="top-separator-md">
                    <AccesoSimultaneo plataformas={props.plataformas} /> 
                </div>
                <ConfiguracionContrasenia alfabetica={props.alfabetica}
                    caracteresEspeciales={props.caracteresEspeciales}
                    caracteresMinimos={props.caracteresMinimos}
                    caseSensitive={props.caseSensitive}
                    numerica={props.numerica}
                    permiteCaracteresIguales={props.permiteCaracteresIguales}
                    permiteLetrasConsecutivas={props.permiteLetrasConsecutivas}
                    permiteNrosConsecutivos={props.permiteNrosConsecutivos}
                    permiteRepetirPosicion={props.permiteRepetirPosicion}/>
            </div>
        </div>
    );
};

export default ModoPersonalizado;